!function() {
  var e, t, r = {
    64: function() {
      window.tagalysDisableLegacyScript = !0;
      const e = () => {
        Tagalys.setConfiguration({
          api: {
            serverUrl: "https://api-r4.tagalys.com",
            credentials: {
              clientCode: window.settings.tagalys.clientCode,
              apiKey: window.settings.tagalys.apiKey
            },
            storeId: window.settings.tagalys.storeId
          },
          locale: `${Shopify.locale}-${Shopify.country}` || "en-GB",
          currency: {
            displayFormatter: Shopify.money_format || "{{currencyLabel}}{{value}}",
            code: Shopify.currency.active || "GBP",
            label: Shopify.money_format.replace("{{amount}}", "").replace(Shopify.currency.active || "GBP", "") || "£",
            fractionalDigits: 2,
            forceFractionalDigits: !0,
            exchangeRate: 1
          },
          analyticsStorageConsentProvided: () => Shopify.customerPrivacy?.userCanBeTracked() || !1,
          track: !0
        }), Tagalys.setPlatformConfiguration({
          platform: "Shopify",
          countryCode: Shopify.country || "GB",
          baseCountryCode: "GB",
          useStorefrontAPIForSecondaryMarkets: !0,
          waitForStorefrontAPI: !0,
          storefrontAPI: {
            accessToken: "7ce3f4c2fac9b8eaf02efbd625145358",
            myShopifyDomain: Shopify.shop || "e243ce-e4.myshopify.com"
          },
          metafields: {
            products: [ {
              namespace: "custom",
              key: "product_colour"
            }, {
              namespace: "custom",
              key: "product_plp_badge"
            }, {
              namespace: "custom",
              key: "product_filter_colour"
            }, {
              namespace: "custom",
              key: "product_subtitle"
            }, {
              namespace: "custom",
              key: "product_colour_swatch"
            }, {
              namespace: "custom",
              key: "product_colour_grouping"
            }, {
              namespace: "custom",
              key: "product_colour_swatch_image"
            } ]
          }
        }), Tagalys.APIConnector.setQueryStringConfiguration({
          queryParameter: "q",
          filterParameter: "f",
          sortParameter: "sort",
          startCursorParameter: "startCursor",
          endCursorParameter: "endCursor"
        }), Tagalys.Analytics.trackPlatformEvents();
      };
      if (window.Tagalys) e(); else {
        const t = setInterval((() => {
          window.Tagalys && (e(), clearInterval(t));
        }), 250);
      }
    }
  }, n = {};
  function o(e) {
    var t = n[e];
    if (void 0 !== t) return t.exports;
    var a = n[e] = {
      exports: {}
    };
    return r[e](a, a.exports, o), a.exports;
  }
  o.m = r, o.d = function(e, t) {
    for (var r in t) o.o(t, r) && !o.o(e, r) && Object.defineProperty(e, r, {
      enumerable: !0,
      get: t[r]
    });
  }, o.f = {}, o.e = function(e) {
    return Promise.all(Object.keys(o.f).reduce((function(t, r) {
      return o.f[r](e, t), t;
    }), []));
  }, o.u = function(e) {
    if (736 === e) return "assets/vendor.736.js";
  }, o.miniCssF = function(e) {}, o.g = function() {
    if ("object" == typeof globalThis) return globalThis;
    try {
      return this || new Function("return this")();
    } catch (e) {
      if ("object" == typeof window) return window;
    }
  }(), o.o = function(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, e = {}, t = "shopify-template:", o.l = function(r, n, a, i) {
    if (e[r]) e[r].push(n); else {
      var s, c;
      if (void 0 !== a) for (var l = document.getElementsByTagName("script"), d = 0; d < l.length; d++) {
        var u = l[d];
        if (u.getAttribute("src") == r || u.getAttribute("data-webpack") == t + a) {
          s = u;
          break;
        }
      }
      s || (c = !0, (s = document.createElement("script")).charset = "utf-8", s.timeout = 120, 
      o.nc && s.setAttribute("nonce", o.nc), s.setAttribute("data-webpack", t + a), s.src = r), 
      e[r] = [ n ];
      var h = function(t, n) {
        s.onerror = s.onload = null, clearTimeout(p);
        var o = e[r];
        if (delete e[r], s.parentNode && s.parentNode.removeChild(s), o && o.forEach((function(e) {
          return e(n);
        })), t) return t(n);
      }, p = setTimeout(h.bind(null, void 0, {
        type: "timeout",
        target: s
      }), 12e4);
      s.onerror = h.bind(null, s.onerror), s.onload = h.bind(null, s.onload), c && document.head.appendChild(s);
    }
  }, o.r = function(e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, function() {
    var e;
    o.g.importScripts && (e = o.g.location + "");
    var t = o.g.document;
    if (!e && t && (t.currentScript && (e = t.currentScript.src), !e)) {
      var r = t.getElementsByTagName("script");
      if (r.length) for (var n = r.length - 1; n > -1 && (!e || !/^http(s?):/.test(e)); ) e = r[n--].src;
    }
    if (!e) throw new Error("Automatic publicPath is not supported in this browser");
    e = e.replace(/#.*$/, "").replace(/\?.*$/, "").replace(/\/[^\/]+$/, "/"), o.p = e + "../";
  }(), function() {
    var e = {
      594: 0
    };
    o.f.j = function(t, r) {
      var n = o.o(e, t) ? e[t] : void 0;
      if (0 !== n) if (n) r.push(n[2]); else {
        var a = new Promise((function(r, o) {
          n = e[t] = [ r, o ];
        }));
        r.push(n[2] = a);
        var i = o.p + o.u(t), s = new Error;
        o.l(i, (function(r) {
          if (o.o(e, t) && (0 !== (n = e[t]) && (e[t] = void 0), n)) {
            var a = r && ("load" === r.type ? "missing" : r.type), i = r && r.target && r.target.src;
            s.message = "Loading chunk " + t + " failed.\n(" + a + ": " + i + ")", s.name = "ChunkLoadError", 
            s.type = a, s.request = i, n[1](s);
          }
        }), "chunk-" + t, t);
      }
    };
    var t = function(t, r) {
      var n, a, i = r[0], s = r[1], c = r[2], l = 0;
      if (i.some((function(t) {
        return 0 !== e[t];
      }))) {
        for (n in s) o.o(s, n) && (o.m[n] = s[n]);
        if (c) c(o);
      }
      for (t && t(r); l < i.length; l++) a = i[l], o.o(e, a) && e[a] && e[a][0](), e[a] = 0;
    }, r = self.webpackChunkshopify_template = self.webpackChunkshopify_template || [];
    r.forEach(t.bind(null, 0)), r.push = t.bind(null, r.push.bind(r));
  }(), function() {
    "use strict";
    o(64);
    customElements.get("predictive-search") || customElements.define("predictive-search", class extends HTMLElement {
      toggle=document.getElementById("Search");
      templates={};
      params={
        request: {
          products: {
            limit: 4
          },
          collections: {
            limit: 3
          },
          pages: {
            limit: 3
          }
        }
      };
      highlight(e) {
        const t = new RegExp(this.params.query, "gi");
        return e.replace(t, '<span class="text-links">$&</span>');
      }
      renderSearchSuggestions(e, t) {
        let r = 0;
        Object.keys(this.params.request).forEach((t => {
          let n = this.querySelector(`[data-search-${t}] ul`), o = "";
          "products" == t ? (r += e[t].length, n.innerHTML = "", this.templates.product ? e[t].forEach((e => {
            const t = window.Liquid.parseAndRenderSync(this.templates.product, {
              product: e
            });
            n.innerHTML += `<li class="col-span-4 tablet:col-span-6">${t}</li>`;
          })) : e[t].forEach((async e => {
            fetch(`${Shopify.routes.root}products/${e.handle}?view=item`).then((e => {
              if (e.ok) return e.text();
            })).then((e => {
              n.innerHTML += `<li class="col-span-4 tablet:col-span-6">${e}</li>`;
            }));
          }))) : (e.queries?.forEach((e => {
            e.section_id == t && (r += e.items.length, e.items.forEach((e => o += `<li><a href="${e.link}" class="text-grey-400 hover:text-links transition-colors">${this.highlight(e.displayString)}</a></li>`)));
          })), n.innerHTML = o);
        })), e.hasOwnProperty("widget_name") ? (this.querySelectorAll("[data-view-all]").forEach((e => e.classList.add("hidden"))), 
        this.querySelectorAll("[data-search-pre]").forEach((e => e.classList.remove("hidden"))), 
        this.querySelectorAll("[data-search-post]").forEach((e => e.classList.add("hidden")))) : (this.querySelectorAll("[data-view-all]").forEach((e => e.classList.remove("hidden"))), 
        this.querySelectorAll("[data-search-pre]").forEach((e => e.classList.add("hidden"))), 
        this.querySelectorAll("[data-search-post]").forEach((e => e.classList.remove("hidden")))), 
        this.toggle.dispatchEvent(new Event("input"));
      }
      initSearchSuggestions() {
        window.searchSuggestions = Tagalys.APIConnector.SearchSuggestions.new({
          params: this.params,
          onSuccess: this.renderSearchSuggestions.bind(this),
          onFailure: (e, t) => {
            console.warn("initSearchSuggestions error: "), console.warn(e);
          }
        });
      }
      updateRecommendedProducts() {
        Tagalys.APIConnector.SmartWidget.call({
          params: {
            widgetId: "e27836754678e5c3409a",
            limit: 4
          },
          onSuccess: this.renderSearchSuggestions.bind(this),
          onFailure: (e, t) => {
            console.warn("updateRecommendedProducts error: "), console.warn(e);
          }
        });
      }
      updateRecommendedSearches() {
        window.searchSuggestions.helpers.getPopularSearches(5).then((e => {
          let t = "";
          e.forEach((e => {
            t += `<li>\n              <a\n                data-suggestion\n                href="${Shopify.routes.root}search?${e.queryString}"\n                class="text-links text-link-links shrink-0 snap-start inline-flex items-center tablet:text-sm border rounded-2xs py-2xs h-lg px-md tablet:px-sm transition-colors outline-none border-border hover:border-links"\n              >\n                ${e.displayString}\n              </a>\n            </li>`;
          })), this.querySelector("[data-search-queries] ul").innerHTML = t;
        }));
      }
      updateRecommendations(e) {
        e.target?.value?.length < 2 && (this.updateRecommendedProducts(), this.updateRecommendedSearches());
      }
      updateSearchSuggestions(e) {
        const t = (e.target || e)?.value;
        window.lastQuery = t, t.length >= 2 ? window.searchSuggestions.helpers.updateQuery(t) : this.updateRecommendations(e);
      }
      addEventListeners() {
        document.querySelectorAll("[data-search-input]").forEach((e => {
          this.updateSearchSuggestions(e), e.addEventListener("focus", (e => {
            this.initLiquidEngine(), this.updateRecommendations(e), this.toggle.checked = !0;
          })), e.addEventListener("keyup", (e => {
            this.updateSearchSuggestions(e), this.querySelectorAll("[data-view-all]").forEach((t => t.href = `${Shopify.routes.root}search?q=${encodeURIComponent(e.target.value)}`));
          }));
        })), this.toggle.addEventListener("input", (e => {
          e.target.checked ? (document.body.classList.add("search-open"), document.body.classList.add("overflow-hidden")) : (document.body.classList.remove("search-open"), 
          document.body.classList.remove("overflow-hidden"));
        }));
      }
      initTemplates() {
        this.querySelectorAll('[type="text/template"]').forEach((e => {
          this.templates[e.title] = e.textContent;
        }));
      }
      initLiquidEngine() {
        window.Liquid ? this.initTemplates() : o.e(736).then(o.bind(o, 736)).then((e => {
          window.Liquid = new e.Liquid, this.initTemplates();
        })).catch((e => {
          console.warn(`Failed to load Liquid engine: ${e}`);
        }));
      }
      init() {
        this.initSearchSuggestions(), this.addEventListeners(), document.querySelectorAll("[data-search-close]").forEach((e => e.addEventListener("click", (e => {
          document.querySelectorAll("[data-search-input]").forEach((e => {
            e.value = "", this.toggle.checked = !1, this.toggle.dispatchEvent(new Event("input"));
          }));
        })))), this.addEventListener("click", (e => {
          e.target.hasAttribute("data-suggestion") && (e.preventDefault(), document.querySelectorAll("[data-search-input]").forEach((t => {
            t.value = e.target.textContent.trim(), t.dispatchEvent(new Event("keyup"));
          })));
        })), this.classList.remove("opacity-0", "!pointer-events-none");
      }
      constructor() {
        super(), this.toggle.checked = !1;
      }
      connectedCallback() {
        if (window.Tagalys && window.Shopify ? this.init() : window.addEventListener("load", (() => this.init())), 
        window.Tagalys) this.init(); else {
          const e = setInterval((() => {
            window.Tagalys && (this.init(), clearInterval(e));
          }), 250);
        }
      }
    });
  }();
}();